<ng-container *ngIf="goBack.canGoBack">
  <button
    mat-icon-button
    *pcpHeaderInject="location"
    matTooltipPosition="after"
    matTooltipShowDelay="500"
    i18n-matTooltip
    matTooltip="Go Back"
    (click)="goBack.goBack()"
  >
    <mat-icon class="mat-icon-rtl-mirror">arrow_back</mat-icon>
  </button>
</ng-container>
